/**
 * @class : FilterPipe
 * @author : Sharath Chalya Nagaraju
 * This will filter the input list based on a string or list of string fields
 */
import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'filter'
})
export class FilterPipe implements PipeTransform {
    /**
     * Returns the list of objects which matches the search text
     *  {any[]} items : array to be filtered
     *  {string} searchText : text to filter on
     *  fields : field or fields on which the search should happen
     *  {any[]} : filtered list
     */
    transform(items: any[], searchText: string, fields?: string[]|string): any[] {
        if (!items) { return []; }
        if (!searchText) { return items; }
        searchText = searchText.toLowerCase().trim();
        if (fields) {
            if (Array.isArray(fields) && fields.length) {
                return this.filterOnField(items, fields, searchText);
            } else if (typeof fields == 'string' && fields) {
                return this.filterOnField(items, [fields], searchText);
 } else {
                return items;
 }
        } else {
            return items.filter(item => {
                return item.toLowerCase().includes(searchText);
            });
        }
    }

    /**
     * Function to filter on a specified field
     *  {any[]} items : array to be filtered
     *  fields
     *  {string} searchText : text to filter on
     *  {any[]} : filtered list
     */
    filterOnField(items: any[], fields: string[], searchText: string): any[] {
        const startsWithItems = items.filter(item => {
            return fields.some(field => item[field] && item[field].toLowerCase().startsWith(searchText));
        });
        const containsItems = items.filter(item => {
            return fields.some(field => item[field] &&
                (!item[field].toLowerCase().startsWith(searchText) &&
                item[field].toLowerCase().includes(searchText)));
        });
        return startsWithItems.concat(containsItems);
    }
}
